import { Box, Tab, Tabs, useTheme } from '@mui/material';
import { memo } from 'react';

export const TabPanel = ({ children, value, selectedValue, ...other }) => {
  return <div hidden={value !== selectedValue} {...other}>{children}</div>;
};

const CustomTabs = ({ value, tabs = [], onChange, children }) => {
  const theme = useTheme();

  return (
    <Box>
      <Tabs
        value={value}
        onChange={(_event, newValue) => onChange(newValue)}
        variant="scrollable"
        scrollButtons="auto"
        sx={{
          minHeight: '30px',
          '& .MuiTabs-indicator': {
            display: 'none', // Hide the default indicator line
          },
        }}
      >
        {tabs.map((tab) => (
          <Tab
            key={tab.value}
            value={tab.value}
            label={tab.label}
            sx={{
              fontSize: '0.75rem',
              minHeight: '30px',
              px: 3, // Increased horizontal padding
              py: 0.5,
              backgroundColor: theme.palette.primary.main,
              color: theme.palette.primary.contrastText,
              '&.Mui-selected': {
                backgroundColor: theme.palette.grey[200],
                color: theme.palette.text.primary,
                borderBottom: `2px solid ${theme.palette.primary.main}`,
              },
            }}
          />
        ))}
      </Tabs>
      {children}
    </Box>
  );
};

export default memo(CustomTabs);
